import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as customTabActions from "../../../../actions/customTabActions";
import * as mainTabActions from "../../../../actions/mainTabActions";
import * as matchingActions from "../../../../actions/matchingActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";
import Modal from "../../../global/generic/Modal";
import SearchInputSelectBox from "../../../global/generic/SearchInputSelectBox";

import imgCloseGray from "../../../../resources/img/svgicons/close-grey.svg";
import imgDispensing from "../../../../resources/img/svgicons/dispensing2.svg";

class MatchingDispenseFormulaModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFandeck: null,
            colorName: ""
        };
    }

    componentDidMount() {
        if (this.props.customFandeckList.length === 0) {
            this.props.dispatchGetAllCustomFandecksAction();
        }

        if (this.props.formula !== null && this.props.formula.color.name !== null) {
            this.setState({colorName: this.props.formula.color.name});
        }
    }

    isInvalid = () => {
        return (
            this.props.formula === null ||
            this.props.formula.realColorantList.length === 0 ||
            this.state.selectedFandeck === null ||
            this.state.colorName.trim().length === 0
        );
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleDispenseClick = () => {
        this.props.dispatchStartFormulaDispensingAction(this.props.tabId);
        this.props.dispatchCloseModalAction();
    };

    setFandeck = (fandeck) => {
        this.setState({selectedFandeck: fandeck});
        this.props.dispatchSelectCustomFandeckAction(this.props.tabId, fandeck);
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleColorNameChange = (event) => {
        this.setState({colorName: event.target.value});
        this.props.dispatchChangeColorNameAction(this.props.tabId, event.target.value.trim());
    };

    handleRemoveColorNameClick = () => {
        this.setState({colorName: ""});
    };

    getColorants = () => {
        let colorants = [];

        for (let colorant of this.props.formula.getRealColorantListByUnit(this.props.formulaUnits)) {
            colorants.push(
                <div key={colorant.id} className="col-12 padding-5 flex flex-wrap">
                    <div className="col-6">
                        <div className="color-square" style={{backgroundColor: colorant.rgb}} />
                        <span>{colorant.displayName}</span>
                    </div>
                    <div className="col-6 color-primary flex">
                        <span className="flex-right">
                            {formatHelper.formatDecimal(colorant.amount)} {colorant.amountType}
                        </span>
                    </div>
                </div>
            );
        }

        return colorants;
    };

    getColorantsPanel = () => {
        if (this.props.formula === null) {
            return null;
        }

        return (
            <div className="col-12">
                <div
                    className="col-12 color-primary"
                    style={{borderBottom: "1px solid", marginBottom: "2vh", marginTop: "3vh"}}
                ></div>
                <div className="col-12">
                    <div className="select-box-description color-primary">
                        <span className="font-size-1_25em">
                            <Translate value={"general.colorants"} />
                        </span>
                    </div>
                </div>
                <div className="col-12">{this.getColorants()}</div>
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <div className="col-12">
                <div className="col-12">
                    <SearchInputSelectBox
                        optionsList={[]}
                        selectedValue={this.props.product}
                        property="displayName"
                        label={translate("general.product")}
                        placeholder={translate("searchPanel.productStartPlaceholder") + "..."}
                        loading={false}
                        disabled={true}
                        valueSelected={() => {}}
                        onChange={() => {}}
                    />
                    <SearchInputSelectBox
                        optionsList={this.props.customFandeckList}
                        selectedValue={this.state.selectedFandeck}
                        property="displayName"
                        label={translate("general.customFandeck")}
                        placeholder=""
                        loading={false}
                        valueSelected={this.setFandeck}
                        onChange={() => {}}
                    />
                    <div className="col-12">
                        <div className="pull-right select-box-description color-primary">
                            <span className="font-size-1_25em">
                                <Translate value="general.colorName" />
                            </span>
                        </div>
                        <div className="col-12 general-multiselect-box primary-multiselect-box select-box search-select-box">
                            <Input
                                className="col-12 svg-icon"
                                type="text"
                                value={this.state.colorName}
                                placeholder=""
                                onFocus={this.handleInputFocus}
                                onChange={this.handleColorNameChange}
                                svgAfter={this.state.colorName === "" ? null : imgCloseGray}
                                svgAfterAction={this.handleRemoveColorNameClick}
                            />
                        </div>
                    </div>
                    <SearchInputSelectBox
                        optionsList={[]}
                        selectedValue={this.props.base}
                        property="displayName"
                        label={translate("general.base")}
                        placeholder={translate("searchPanel.baseStartPlaceholder") + "..."}
                        loading={false}
                        disabled={true}
                        valueSelected={() => {}}
                        onChange={() => {}}
                    />
                    <SearchInputSelectBox
                        optionsList={[]}
                        selectedValue={this.props.package}
                        property="displayName"
                        label={translate("general.package")}
                        placeholder={translate("searchPanel.packageStartPlaceholder") + "..."}
                        loading={false}
                        disabled={true}
                        valueSelected={() => {}}
                        onChange={() => {}}
                    />
                </div>
                {this.getColorantsPanel()}
            </div>,
            "slim-scroll"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <CancelButton onClick={this.handleCloseModalClick} />
                <Button
                    className="svg-ratio-2_1 force-show-svg"
                    svgBefore={imgDispensing}
                    label={translate("general.dispense")}
                    disabled={this.isInvalid()}
                    onClick={this.handleDispenseClick}
                />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("matching.confirmDispensing"))}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "30%", height: "65vh"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.matchingTab[ownProps.tabId] === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            customFandeckList: [],
            product: null,
            base: null,
            package: null,
            formula: null,
            formulaUnits: store.settings.formulaUnits
        };
    }

    return {
        customFandeckList: store.global.customFandeckList,
        product: store.formula[ownProps.tabId].product,
        base: store.formula[ownProps.tabId].base,
        package: store.formula[ownProps.tabId].package,
        formula: store.formula[ownProps.tabId].formula,
        formulaUnits: store.settings.formulaUnits
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MATCHING_DISPENSE_FORMULA_MODAL));
        },
        dispatchGetAllCustomFandecksAction: () => {
            dispatch(customTabActions.getAllCustomFandecks());
        },
        dispatchSelectCustomFandeckAction: (tabId, fandeck) => {
            dispatch(matchingActions.selectCustomFandeck(tabId, fandeck));
        },
        dispatchChangeColorNameAction: (tabId, colorName) => {
            dispatch(matchingActions.changeColorName(tabId, colorName));
        },
        dispatchStartFormulaDispensingAction: (tabId) => {
            dispatch(mainTabActions.startFormulaDispensing(tabId));
        }
    };
};

export default MatchingDispenseFormulaModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(MatchingDispenseFormulaModal);
